const question = [
  // part1
  {
    id: 1,
    question: '你認為應該由何種人<br>來帶領全球淨零轉型？',
    answer: [
      {
        id: 1,
        contnet: '有信用，言出必行',
        score: [0, 1, 0],
      },
      {
        id: 2,
        contnet: '最強大腦，知識豐富',
        score: [1, 0, 0],
      },
      {
        id: 3,
        contnet: '整合能力強，知人善任',
        score: [0, 0, 1],
      }
    ]
  },
  {
    id: 2,
    question: '你覺得哪一個面向的策略最為重要？',
    answer: [
      {
        id: 1,
        contnet: '資源循環永續科技',
        score: [1, 0, 0],
      },
      {
        id: 2,
        contnet: '環境保育生態復原',
        score: [0, 0, 1],
      },
      {
        id: 3,
        contnet: '民生經濟永續投資',
        score: [0, 1, 0],
      }
    ]
  },
  {
    id: 3,
    question: '你認為永續策略中最應著重何者?',
    answer: [
      {
        id: 1,
        contnet: '策略的可行性',
        score: [0, 1, 0],
      },
      {
        id: 2,
        contnet: '策略的未來性',
        score: [0, 0, 1],
      },
      {
        id: 3,
        contnet: '策略的彈性及調整空間',
        score: [1, 0, 0],
      }
    ]
  },
  {
    id: 4,
    question: '你最常接收來自哪一個面向的資訊?',
    answer: [
      {
        id: 1,
        contnet: '領域專家學者',
        score: [1, 0, 0],
      },
      {
        id: 2,
        contnet: '企業',
        score: [0, 1, 0],
      },
      {
        id: 3,
        contnet: '環保公益團體',
        score: [0, 0, 1],
      }
    ]
  },
  {
    id: 5,
    question: '你會用什麼方式，和不同想法的朋友討論觀點？',
    answer: [
      {
        id: 1,
        contnet: '直球對決，當面討論',
        score: [0, 1, 0],
      },
      {
        id: 2,
        contnet: '在社群媒體發文，舌戰群儒',
        score: [1, 0, 0],
      },
      {
        id: 3,
        contnet: '蒐集案例資料，研究探討',
        score: [0, 0, 1],
      }
    ]
  },
  // part2
  {
    id: 6,
    question: '你對地球的未來，抱持何種態度？',
    answer: [
      {
        id: 1,
        contnet: '樂觀，只要努力一定可以改善',
        score: [0, 0, 1],
      },
      {
        id: 2,
        contnet: '觀望，目前仍缺乏關鍵技術',
        score: [1, 0, 0],
      },
      {
        id: 3,
        contnet: '悲觀，沒救了準備移民火星',
        score: [0, 1, 0],
      }
    ]
  },
  {
    id: 7,
    question: '你認為現今淨零最缺乏的是什麼？',
    answer: [
      {
        id: 1,
        contnet: '突破性技術發展',
        score: [1, 0, 0],
      },
      {
        id: 2,
        contnet: '懲罰排放的機制',
        score: [0, 0, 1],
      },
      {
        id: 3,
        contnet: '資金投入協助轉型',
        score: [0, 1, 0],
      }
    ]
  },
  {
    id: 8,
    question: '你最想要以什麼形式對淨零做出貢獻？',
    answer: [
      {
        id: 1,
        contnet: '改變消費習慣，參與淨零行動',
        score: [0, 0, 1],
      },
      {
        id: 2,
        contnet: '進入產業，實際發展減碳技術',
        score: [1, 0, 0],
      },
      {
        id: 3,
        contnet: '分享資訊，贊助永續公益',
        score: [0, 1, 0],
      }
    ]
  },
  {
    id: 9,
    question: '如果可以預知一件關於2050年的事情，你會想知道什麼？',
    answer: [
      {
        id: 1,
        contnet: '未來的科技發展',
        score: [1, 0, 0],
      },
      {
        id: 2,
        contnet: '未來人類生活型態',
        score: [0, 0, 1],
      },
      {
        id: 3,
        contnet: '未來文化音樂藝術',
        score: [0, 1, 0],
      }
    ]
  },
  {
    id: 10,
    question: '經過二手市集，你最願意購買的物品會是？',
    answer: [
      {
        id: 1,
        contnet: '閱讀完的書籍',
        score: [1, 0, 0],
      },
      {
        id: 2,
        contnet: '還可以使用的裝飾品',
        score: [0, 1, 0],
      },
      {
        id: 3,
        contnet: '乾淨整齊的二手衣服',
        score: [0, 0, 1],
      }
    ]
  }
]


const result_part1 = [
  {
    id: 1,
    type: "A",
    people: "永續科學家",
    info: "精益求精，善於解決問題",
    content: '科學家富有使命感，絕對不會放棄尋求解答。擁有卓越的分析和問題解決能力，能夠理解生態、環境、社會和經濟系統之間的複雜相互關係。',
    image: 'people_scientist.png',
    partner: '雨林鳥',
    partnerImg: 'animal_5_head.png',
  },
  {
    id: 2,
    type: "F",
    people: "永續藝術家",
    info: "獨樹一格，未來想像在手裡",
    content: '具備創意和想像力，能夠表達獨特的觀點和情感是藝術家的特質。對於永續議題敏銳觀察、深刻思考，並勇於挑戰傳統。',
    image: 'people_artist.png',
    partner: '荒原豹',
    partnerImg: 'animal_3_head.png',
  },
  {
    id: 3,
    type: "C",
    people: "永續天文家",
    info: "夜觀星斗，超越宇宙觀",
    content: '永續領域的議題變化快而複雜，天文學家能見微知著，提前判定情勢。具有務實的觀測技巧及數據分析能力，準確預知未來。',
    image: 'people_astronomer.png',
    partner: '溪流獺',
    partnerImg: 'animal_1_head.png',
  },
  {
    id: 4,
    type: "E",
    people: "永續農夫",
    info: "精益求精，善於解決問題",
    content: '以穩定務實的態度，識別關鍵問題、 制定有效方案並付諸具體行動， 是領導農夫選擇邁向永續具備的能力。',
    image: 'people_framer.png',
    partner: '田園犬',
    partnerImg: 'animal_6_head.png',
  },
  {
    id: 5,
    type: "D",
    people: "永續公益鬥士",
    info: "熱情奔放，帶領群體行動",
    content: '公益鬥士有著堅定不移的信念，具備同理心和關懷他人的特質。有很強的組織能力，針對永續議題和各方有效的溝通，實現公益使命。',
    image: 'people_love.png',
    partner: '草原獴',
    partnerImg: 'animal_4_head.png',
  },
  {
    id: 6,
    type: "B",
    people: "永續金融家",
    info: "判讀經濟情勢，搶佔關鍵商機",
    content: '天天面對大幅波動的市場，磨練出金融家冷靜的領導力和決策技巧。能夠理解永續領域的風險和機會，運用溝通技巧、謹慎的態度面對各種挑戰。',
    image: 'people_financier.png',
    partner: '森林蟒',
    partnerImg: 'animal_2_head.png',
  },
]


const result_part2 = [
  {
    id: 1,
    type: "F",
    animal: "荒原豹",
    info: "獨來獨往、魅力驚人",
    content: '有卓越的觀察力和決策能力，瞭解自己的極限，只在確信成功時發起精準攻擊。淨零的策略多樣而複雜，豹能夠冷靜分析，自信帶領您一擊中的。',
    image: 'animal_leopard.png',
  },
  {
    id: 2,
    type: "D",
    animal: "草原獴",
    info: "群居生活、關注危機",
    content: '狐獴聰明、好奇且靈活，常結成群體，互相合作狩獵或分享食物。他們瞻前顧後，能敏銳的替您辨識前方的困難與危機。',
    image: 'animal_mongoose.png',
  },
  {
    id: 3,
    type: "C",
    animal: "溪流獺",
    info: "高枕好眠、與世無爭",
    content: '個性活潑而愛玩，常以家庭群體生活，互相合作捕食、照顧幼崽，並共同維護巢穴。面對高度不確定的永續未來，能給予穩定的陪伴跟支持。',
    image: 'animal_otter.png',
  },
  {
    id: 4,
    type: "B",
    animal: "森林蟒",
    info: "踞高遠望、務實穩定",
    content: '通常冷靜、沉默寡言，以潛伏和伺機狩獵為主，表現出高度的專注和效率。面對潛在威脅時，蟒蛇通常選擇逃避而非攻擊，是淨零旅途上非常可靠的夥伴。',
    image: 'animal_snake.png',
  },
  {
    id: 5,
    type: "A",
    animal: "雨林鳥",
    info: "高聲疾呼、伴風翱翔",
    content: '性格溫馴，以群體合作保護巢穴、照顧幼鳥。 永續工作執行困難，社交性鳥類有多元的溝通方式， 能以有趣和溫暖的溝通表現，帶您彩繪永續之路。',
    image: 'animal_bird.png',
  },
  {
    id: 6,
    type: "E",
    animal: "田園犬",
    info: "聰明靈巧、忠實陪伴",
    content: '田園犬勇敢且適應能力強，有強烈的領土本能，保護家園免受入侵。對於未來感到徬徨或無助之時，能夠給予溫暖及肯定，忠實伴您度過低谷。',
    image: 'animal_dog.png',
  },
]

// ------------------------------------

// 參數
let questionNum = 0;
let stepNum = 0;
let score_part1 = [0, 0, 0];
let score_part2 = [0, 0, 0];
let result_people;
let result_animal;
let people_type;
let animal_type;


// function
function init() {
  setStep(0)
}


$('.step0.btn').click(function () {
  setStep(1)
})

$('.con.bg .logo-spacc').click(function () {
  $(".con.lightbox").fadeIn()
})

$('.con.lightbox .close, .con.lightbox').click(function () {
  $(".con.lightbox").fadeOut()
})

$('.con.lightbox .logoArea').click(function () {
  return false;
})

$('.con.lightbox .logoArea a').click(function () {
  window.open(`${this.getAttribute('href')}`, '_blank')
})

function addArrays(arr1, arr2) {
  var result = [];
  var maxLength = Math.max(arr1.length, arr2.length);
  var carry = 0;

  for (var i = 0; i < maxLength; i++) {
    var num1 = arr1[i] || 0;
    var num2 = arr2[i] || 0;
    var sum = num1 + num2 + carry;
    carry = Math.floor(sum / 10);
    result.push(sum % 10);
  }

  if (carry > 0) {
    result.push(carry);
  }

  return result;
}

function findIndicesOfElement(arr, element) {
  var indices = [];
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === element) {
      indices.push(i);
    }
  }
  return indices;
}


function calcResult() {

  // people
  if (score_part1.includes(2)) {
    var indices = findIndicesOfElement(score_part1, 1);
    if (indices.length == 0) {
      var indices = findIndicesOfElement(score_part1, 0);
    }
    if (indices[0] == 0) {
      people_type = 'D'
      result_people = 4
    } else if (indices[0] == 1) {
      people_type = 'B'
      result_people = 5
    } else {
      people_type = 'E'
      result_people = 3
    }
  } else {
    if (score_part1.includes(3)) {
      // 3,1,1
      var indices = findIndicesOfElement(score_part1, 3);
    } else if (score_part1.includes(4)) {
      // 4,1,0
      var indices = findIndicesOfElement(score_part1, 4);
    } else if (score_part1.includes(5)) {
      // 5,0,0
      var indices = findIndicesOfElement(score_part1, 5);
    }
    result_people = indices[0]
    people_type = result_part1[result_people].type
  }

  $(".result .part1 > h3").html(`${result_part1[result_people].people}`)
  $(".result .part1 img").attr('src', `./assets/image/answer/${result_part1[result_people].image}`)
  $(".result .part1 .info h3").html(`${result_part1[result_people].info}`)
  $(".result .part1 .info p").html(`${result_part1[result_people].content}`)
  $(".result .part3 h3").html(`${result_part1[result_people].partner}`)
  $(".result .part3 img").attr('src', `./assets/image/animal/${result_part1[result_people].partnerImg}`)

  // animal
  if (score_part2.includes(2)) {
    var indices = findIndicesOfElement(score_part2, 1);
    if (indices.length == 0) {
      var indices = findIndicesOfElement(score_part2, 0);
    }
    if (indices[0] == 0) {
      animal_type = 'A'
      result_animal = 4
    } else if (indices[0] == 1) {
      animal_type = 'E'
      result_animal = 5
    } else {
      animal_type = 'B'
      result_animal = 3
    }
  } else {
    if (score_part2.includes(3)) {
      // 3,1,1
      var indices = findIndicesOfElement(score_part2, 3);
    } else if (score_part2.includes(4)) {
      // 4,1,0
      var indices = findIndicesOfElement(score_part2, 4);
    } else if (score_part2.includes(5)) {
      // 5,0,0
      var indices = findIndicesOfElement(score_part2, 5);
    }
    result_animal = indices[0]
    animal_type = result_part2[result_animal].type
  }

  $(".result .part2 > h3").html(`${result_part2[result_animal].animal}`)
  $(".result .part2 img").attr('src', `./assets/image/answer/${result_part2[result_animal].image}`)
  $(".result .part2 .info h3").html(`${result_part2[result_animal].info}`)
  $(".result .part2 .info p").html(`${result_part2[result_animal].content}`)


  if (people_type == animal_type) {
    $(".result .part3").css('display', 'none')
    $(".result .part2 span").css('display', 'block')
  } else {
    $(".result .part3").css('display', 'block')
    $(".result .part2 span").css('display', 'none')
  }

}

function setEvent() {
  $('.step1 .answer li').click(function () {
    // 分數計算
    $('.step1 .answer').css('pointer-events', 'none')
    question[questionNum].answer.forEach(element => {
      if ($(this).html() == element.contnet) {

        if (questionNum < 5) {
          score_part1 = addArrays(score_part1, element.score)
        } else {
          score_part2 = addArrays(score_part2, element.score)
        }
      }
    });
    if (questionNum !== 4 && questionNum !== 9) {
      questionNum++;
      setQuestion()
    } else if (questionNum == 4) {
      $('.step1').css('display', 'none')
      $('.bg-people_white_shadow').css({
        'top': '100%',
        'opacity': '0'
      })
      setTimeout(function () {
        $('.rest').fadeIn()
      }, 250)
      $('.step1 .animal').css('display', 'block')
      $('.rest .btn').click(function () {
        $('.rest').css('display', 'none')
        $('.bg-earth').css('top', '100%')
        setTimeout(function () {
          $('.bg-mountain').css('bottom', '0%')
        }, 50)
        questionNum++;
        setQuestion()
      })
    } else if (questionNum == 9) {
      $('.step1').css('display', 'none')
      $('.rest h3').html('結果計算中')
      $('.rest h3').addClass('active')
      $('.rest .btn').css('opacity', '0')
      if (window.innerHeight > window.innerWidth && window.innerWidth > 550) {
        $('.bg-earth').css('top', 'calc(100% - 120px)')
      } else {
        $('.bg-earth').css('top', 'calc(100% - 90px)')
      }
      setTimeout(function () {
        $('.rest').fadeIn()
      }, 250)

      setTimeout(function () {
        // 計算分數
        calcResult()
      }, 1000)

      setTimeout(function () {
        setStep(2)
      }, 2400)
    }
  })
}

function setQuestion() {
  if (questionNum == 0) {
    $('.step1 > p').css('opacity', '0')
    $('.step1 .num').css('opacity', '0')
  }
  $('.step1 .question').css('transition', '0s')
  $('.step1 .answer').css('transition', '0s')
  $('.step1 .question').css('opacity', '0')
  $('.step1 .answer').css('opacity', '0')
  $('.step1 > p').html(`Q${questionNum + 1}`)
  $('.step1 .question h3').html(`${question[questionNum].question}`)
  $('.step1 .num span').html(`${questionNum + 1}`)
  $('.content').addClass('middle40')
  if (questionNum > 4) {
    $('.content').addClass('middle45')
    $('.content').removeClass('middle40')
  } else {
    $('.content').addClass('middle40')
    $('.content').removeClass('middle45')
  }
  let answer = ''
  question[questionNum].answer.forEach(element => {
    answer += `<li>${element.contnet}</li>`
  });
  $('.step1 .answer ul').html(`${answer}`)

  setTimeout(function () {
    $('.step1 > p').css('opacity', '1')
    $('.step1 .num').css('opacity', '1')
    $('.step1').fadeIn()
    $('.step1 .question').css('transition', '0.3s')
    $('.step1 .answer').css('transition', '0.3s')
    $('.step1 .question').css('opacity', '1')
    $('.step1 .answer').css('opacity', '1')
    $('.step1 .answer').css('pointer-events', 'unset')
  }, 330)

  setEvent()
}

function setStep(num) {
  switch (num) {
    // 測驗
    case 1: {
      stepNum = 1
      $('.step').css('display', 'none')
      $('.step1').fadeIn()
      $('.bg-mountain').css('bottom', '-40%')
      $('.bg-snake').css('left', '-30%')
      $('.bg-bird').css('right', '-30%')
      $('.bg-dog').css('right', '-30%')
      $('.bg-tiger').css('left', '-30%')
      setQuestion()
      setTimeout(function () {
        if (window.innerWidth > 550) {
          $('.bg-people_white_shadow').css({
            'top': 'calc(66%)',
            'opacity': '1'
          })
        } else {
          $('.bg-people_white_shadow').css({
            'top': 'calc(80% - 50px)',
            'opacity': '1'
          })
        }
      }, 50)
      setTimeout(function () {
        $('.logo-gameName').fadeIn()
        if (window.innerWidth > 550) {
          $('.bg-earth').css('top', 'calc(75%)')
        } else {
          $('.bg-earth').css('top', 'calc(80%)')
        }
      }, 250)
      break;
    }
    // 結果
    case 2: {
      stepNum = 2

      $('.step').css('display', 'none')
      $('.content').addClass('auto')
      $('.content').removeClass('middle40')
      $('.content').removeClass('middle45')
      $('.content').addClass('middle50')
      $('.rest').css('display', 'none')
      $('.result').fadeIn()

      // $('.result .clickOpen').click(function () {
      //     $('.popup').fadeIn()
      //     $('.result').css('display', 'none')
      //     $('.content').removeClass('auto')
      //     $('.content').css('max-width', '70%')
      //     setTimeout(function () {
      //         // ::todo 補連結
      //         window.open(``, '_self')
      //     }, 2000)
      // })
      $('.result .playAgain').click(function () {
        location.reload()
      })
      break;
    }
    // 預設
    default: {
      stepNum = 0
      questionNum = 0
      $('.step0').fadeIn()
      $('.result').css('display', 'none')
      $('.logo-gameName').fadeOut()
      $('.bg-snake').css('left', '0%')
      $('.bg-bird').css('right', '-3%')
      $('.bg-dog').css('right', '10%')
      $('.bg-tiger').css('left', '6%')
      break;
    }
  }

}


init()

